// Lalive: arrow buttons for horizontal tracks (product strip). Native scroll
// does the rest; arrows only nudge by one card and disable at the ends.
(() => {
  if (window.__lvTracks) return;
  window.__lvTracks = true;

  const step = (track) => {
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
  };

  const sync = (track) => {
    const prev = document.querySelector(`[data-lv-prev="${track.id}"]`);
    const next = document.querySelector(`[data-lv-next="${track.id}"]`);
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-lv-prev],[data-lv-next]');
    if (!btn) return;
    const id = btn.dataset.lvPrev || btn.dataset.lvNext;
    const track = document.getElementById(id);
    if (!track) return;
    const dir = btn.dataset.lvPrev ? -1 : 1;
    track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
  });

  const init = () => {
    document.querySelectorAll('.lv-track[id]').forEach((track) => {
      if (track.dataset.lvSynced) return;
      track.dataset.lvSynced = '1';
      sync(track);
      track.addEventListener('scroll', () => sync(track), { passive: true });
      // Tracks filled after load (UGC feed) re-evaluate their arrows.
      new MutationObserver(() => sync(track)).observe(track, { childList: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// Lalive: filter chips ([data-lv-filter]) show one group ([data-lv-filter-item])
// inside the nearest [data-lv-filter-scope]; an empty value shows all. Without
// JS every group stays visible. Used by Sipariş noktaları (cities).
(() => {
  if (window.__lvFilter) return;
  window.__lvFilter = true;
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-lv-filter]');
    if (!chip) return;
    const scope = chip.closest('[data-lv-filter-scope]');
    if (!scope) return;
    const value = chip.dataset.lvFilter;
    scope.querySelectorAll('[data-lv-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
    scope.querySelectorAll('[data-lv-filter-item]').forEach((item) => {
      item.hidden = Boolean(value) && item.dataset.lvFilterItem !== value;
    });
  });
})();

// Lalive: "Bağlantıyı kopyala" buttons ([data-lv-copy]) on articles (round 4).
(() => {
  if (window.__lvCopy) return;
  window.__lvCopy = true;
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-lv-copy]');
    if (!btn) return;
    try {
      await navigator.clipboard.writeText(btn.dataset.lvCopy);
      const label = btn.textContent;
      btn.textContent = btn.dataset.lvCopied || label;
      setTimeout(() => (btn.textContent = label), 2000);
    } catch (e) {
      window.prompt('', btn.dataset.lvCopy);
    }
  });
})();

// Lalive: gift choice in the cart (snippets/lv-cart-threshold, K25). The first
// tap locks the list so a double tap cannot add two bags (only one is free).
// The drawer re-renders after the add; the lock lifts on its own if it doesn't.
(() => {
  if (window.__lvGift) return;
  window.__lvGift = true;
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.lv-gift__add .add-to-cart-button');
    const list = btn && btn.closest('.lv-gift');
    if (!list) return;
    if (list.classList.contains('is-busy')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    list.classList.add('is-busy');
    setTimeout(() => list.classList.remove('is-busy'), 6000);
  }, true);
})();
